import { useQuery } from '@tanstack/react-query';
import { useState, useEffect } from 'react';
import { fetchOrderLegs } from '../api';
/**
 * Custom hook to fetch and manage shipments data
 * In a real application, this would fetch from an API
 */
export function useShipmentsData(orderId, page = 1, limit = 25) {
    var _a, _b, _c;
    const query = useQuery({
        queryKey: ['order-legs', orderId, page, limit],
        enabled: Boolean(orderId),
        queryFn: () => fetchOrderLegs(orderId, page, limit),
        staleTime: 30000,
    });
    const [shipments, setShipments] = useState((_a = query.data) !== null && _a !== void 0 ? _a : []);
    useEffect(() => {
        if (query.data)
            setShipments(query.data);
    }, [query.data]);
    return {
        shipments,
        setShipments,
        isLoading: query.isLoading,
        error: (_c = (_b = query.error) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : null,
    };
}
